import RegisterAddressView from "./view";
import { useNavigate } from "react-router-dom";
import useAddressForm from "../hooks/useAddressForm";

export default function RegisterAddress() {
  const navigate = useNavigate();

  const {
    toggleModal,
    isVisibleModal,
    isLoading,
    isDisabled,
    register,
    handleSubmit,
    errors,
    editable,
  } = useAddressForm(navigate);

  const goBack = () => navigate(-1);

  return (
    <RegisterAddressView
      goBack={goBack}
      isDisabled={isDisabled}
      editable={editable}
      isLoading={isLoading}
      register={register}
      errors={errors}
      handleSubmit={handleSubmit}
      isVisibleModal={isVisibleModal}
      toggleModal={toggleModal}
    />
  );
}
